import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import getCategories from '../../utils/getCategories';
import styles from '../HamburgerMenu/HamburgerMenu.module.scss';
import categoryStyles from './Categories.module.scss';

const Categories: FC = () => (
  <>
    {getCategories().map((category: string) => (
      <Link to={`/product-list/${category}`} className={styles.linkStyle} key={category}>
        <li className={categoryStyles.list}>{category}</li>
      </Link>
    ))}
  </>
);
export default Categories;
